// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5066":"f8b0056e","5478":"d1d5aac6"}[chunkId] + ".chunk.css";
};